import {
  CalendarState,
  CalendarActionTypes,
} from '../../components/Calendar/types';

const initialState: CalendarState = {
  events: [],
  selectedEvent: null,
  loading: false,
  error: null,
  filters: {},
  feedToken: null,
  syncStatus: 'idle',
};

export const calendarReducer = (
  state = initialState,
  action: CalendarActionTypes
): CalendarState => {
  switch (action.type) {
    case 'FETCH_CALENDAR_EVENTS_LOADING':
      return { ...state, loading: true, error: null };

    case 'FETCH_CALENDAR_EVENTS':
      return { ...state, events: action.payload, loading: false, error: null };

    case 'FETCH_CALENDAR_EVENTS_ERROR':
      return { ...state, loading: false, error: action.payload };

    case 'SET_CALENDAR_EVENT':
      return { ...state, selectedEvent: action.payload };

    case 'CREATE_CALENDAR_EVENT':
      return { ...state, events: [...state.events, action.payload] };

    case 'UPDATE_CALENDAR_EVENT':
      return {
        ...state,
        events: state.events.map((evt) =>
          evt.uuid === action.payload.uuid ? action.payload : evt
        ),
        selectedEvent:
          state.selectedEvent?.uuid === action.payload.uuid
            ? action.payload
            : state.selectedEvent,
      };

    case 'DELETE_CALENDAR_EVENT':
      return {
        ...state,
        events: state.events.filter((evt) => evt.uuid !== action.payload),
        selectedEvent:
          state.selectedEvent?.uuid === action.payload
            ? null
            : state.selectedEvent,
      };

    case 'SET_CALENDAR_FILTERS':
      return { ...state, filters: { ...state.filters, ...action.payload } };

    case 'SET_CALENDAR_FEED_TOKEN':
      return { ...state, feedToken: action.payload };

    case 'SET_CALENDAR_SYNC_STATUS':
      return { ...state, syncStatus: action.payload };

    case 'CLEAR_CALENDAR_EVENTS':
      return { ...initialState };

    default:
      return state;
  }
};
